﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { applyThemeStyles } from "~base/Styling";
import { createUseStyles } from "react-jss";
import {
    AccessDeniedPageCustomizations,
    AccessDeniedPageDefaultCustomization,
} from "./Customization";
import { JssClass } from "~base/Styling";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface ReactComponentClasses {
    header: string;
    bottom: string;
    splashButton: string;
}

export interface ReactComponentStyles {
    header: JssClass;
    bottom: JssClass;
    splashButton: JssClass;
}

export const useAdditionalStyles = (
    customization?: AccessDeniedPageCustomizations
): (() => ReactComponentClasses) =>
    createUseStyles((theme: ConsilioBaseTheme): ReactComponentStyles => {
        const styles = {
            header: applyThemeStyles(
                AccessDeniedPageDefaultCustomization.customStyles.header,
                {},
                customization.customStyles?.header
            ),

            bottom: applyThemeStyles(
                AccessDeniedPageDefaultCustomization.customStyles.bottom,
                {},
                customization.customStyles?.bottom
            ),
            splashButton: applyThemeStyles(
                theme.components.pages.shared.splashPage.splashScreen,
                {}
            ),
        };

        return styles;
    }) as () => ReactComponentClasses;
